// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1EVhy","colBig":"styles_colBig__34W0-","colSmall":"styles_colSmall__1pjsO"};